import React, { useEffect } from 'react';
import { Modal } from 'reactstrap';

// reactstrap bloquea el scroll de la página mientras hay un modal abierto (clase
// `modal-open` + `overflow: hidden` en <body>) y lleva la cuenta de modales abiertos en
// un contador estático (Modal.openCount). Si un modal se vuelve a abrir antes de que
// termine la animación de cierre anterior (doble toque en un gráfico, o abrir/cerrar
// rápido los modales anidados de ChildsModal), ese contador queda desfasado: al cerrar
// el último modal reactstrap cree que todavía queda otro abierto y nunca devuelve el
// scroll — la página queda trabada hasta recargarla completa.
//
// Este wrapper, después de que reactstrap termina su propio cierre, verifica si de
// verdad no queda ningún modal visible y en ese caso libera el scroll y resetea el
// contador. Usarlo en lugar del Modal de reactstrap en toda la app.
export const releaseBodyScrollIfNoModalOpen = () => {
    if (document.querySelector('.modal.show')) return;

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    Modal.openCount = 0;
};

const SafeModal = ({ onClosed, ...props }) => {
    // Desmontar un modal abierto (ej. `{loading && <Loading .../>}` en app.jsx) no pasa por
    // onClosed — también se verifica al desmontar.
    useEffect(() => () => { setTimeout(releaseBodyScrollIfNoModalOpen, 0); }, []);

    return (
        <Modal
            {...props}
            onClosed={() => {
                if (onClosed) onClosed();
                // reactstrap llama a onClosed ANTES de su propio close() (que es el que toca
                // <body>) — se difiere para correr después y no ser pisado por él.
                setTimeout(releaseBodyScrollIfNoModalOpen, 0);
            }}
        />
    );
};

export default SafeModal;
